  <app-navigation></app-navigation> 
 
   <app-title-box title="Messages"></app-title-box>

   <div class="container bg-white">
   <ul class="nav nav-tabs" id="myTab" role="tablist">
     <li class="nav-item">
        <a class="nav-link active" id="received-tab" data-toggle="tab" href="#received" role="tab" aria-controls="contact" aria-selected="false" (click)="filter('received')">Received</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" id="sent-tab" data-toggle="tab" href="#sent" role="tab" aria-controls="profile" aria-selected="false" (click)="filter('sended')">Sent</a>
      </li>
      <li class="nav-item" *ngIf="user.isAdmin">
        <a class="nav-link" id="compose-tab" data-toggle="tab" href="#compose" role="tab" aria-controls="profile" aria-selected="false" (click)="filter('compose')">Mass Mail</a>
      </li>
      <li class="nav-item" *ngIf="user.isAdmin">
        <a class="nav-link" id="compose-tab" data-toggle="tab" href="#listing" role="tab" aria-controls="profile" aria-selected="false" (click)="filter('listing')">Lists</a> 
      </li>
    </ul>
<div class="tab-content" id="myTabContent"> 
  <div class="tab-pane active" id="received" role="tabpanel" aria-labelledby="received-tab">
  <table class="table table-bordered table-hover bg-white">
      <tbody *ngIf="received">
        <tr *ngFor="let item of received">
           <td *ngIf="item.Check==0"><a href="javascript:void(0)" routerLink="/messagedetail/{{item.PkMessage}}"><i class="fa fa-envelope"></i></a></td>
          <td *ngIf="item.Check==1"><a href="javascript:void(0)" routerLink="/messagedetail/{{item.PkMessage}}"><i class="fa fa-envelope-open"></i></a></td>
          <td>{{item.Title}}</td>
          <td>{{item.Date}}</td>  
          <td>{{item.Label}}</td>
          <td>{{item.Message | truncate : 50}}</td>
          <!--<td><a href="javascript:void(0)" (click)="deleteMsg(item.PkMessage)"><i class="fa fa-trash-alt"></i></a></td>-->
        </tr>
         <tr *ngIf="received.length<1"><td colspan="4">No messages found</td></tr>
      </tbody>
    </table>
  </div>
  <div class="tab-pane fade" id="sent" role="tabpanel" aria-labelledby="contact-tab">
    <table class="table table-bordered table-hover bg-white">
      <tbody *ngIf="sent">
        <tr *ngFor="let item of sent">
          <td *ngIf="item.Check==0"><a href="javascript:void(0)" routerLink="/messagedetail/{{item.PkMessage}}"><i class="fa fa-envelope"></i></a></td>
          <td *ngIf="item.Check==1"><a href="javascript:void(0)" routerLink="/messagedetail/{{item.PkMessage}}"><i class="fa fa-envelope-open"></i></a></td>
          <td>{{item.Title}}</td>
          <td>{{item.Date}}</td>
          <td>{{item.Label}}</td>
          <td>{{item.Message | truncate : 50}}</td>
          <!-- <td><a href="javascript:void(0)" (click)="deleteMsg(item.PkMessage)"><i class="fa fa-trash-alt"></i></a></td> -->
        </tr>
         <tr *ngIf="sent.length<1"><td colspan="4">No messages found</td></tr>
      </tbody>
    </table>
  </div>
  <div class="tab-pane fade" id="compose" role="tabpanel" aria-labelledby="compose-tab">
    <div class="row w-100 mb-1 mt-4">
      <div class="col-2">&nbsp;</div>
      <div class="col-8">Select list from dropdown and compose the message</div>
      <div class="col-2">&nbsp;</div>
    </div>
     <div class="row w-100 mb-4 mt-4">      
      <div class="col-2  text-right">List</div>
      <div class="col-8">
        <select name="lista" id="lista" [(ngModel)]="selLista">
          <option value="0">Select</option>
          <option *ngFor="let item of adminLists" [value]="item.value">{{item.label}}</option>
        </select>        
      </div>
      <div class="col-2">&nbsp;</div>
    </div>
     <div class="row w-100 mb-4">      
      <div class="col-2 text-right">Subject</div>
      <div class="col-8">                
          <input type="text" class="form-control" name="subject" id="subject" [(ngModel)]="subject">        
      </div>
      <div class="col-2">&nbsp;</div>
    </div>
     <div class="row w-100 mb-4 mt-4">
      <div class="col-2">&nbsp;</div>
      <div class="col-8">
        <ckeditor
          [(ngModel)]="ckeditorContent"
          [config]="{uiColor: '#CCCCCC',removeButtons: 'Image,Flash,PageBreak,Iframe,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,BidiLtr,BidiRtl,Language'}"
          [readonly]="false"
          (change)="onChange($event)"
          (editorChange)="onEditorChange($event)"
          (ready)="onReady($event)"
          (focus)="onFocus($event)"
          (blur)="onBlur($event)"
          (contentDom)="onContentDom($event)"         
          (paste)="onPaste($event)"
          (drop)="onDrop($event)"
          debounce="500">
        </ckeditor>
      </div>
      <div class="col-2">&nbsp;</div>
    </div>
     <div class="row w-100 mb-4 mt-4">
      <div class="col-2">&nbsp;</div>
      <div class="d-flex col-8 justify-content-end"><button class="btn btn-outline-secondary" (click)="sendContent()">Send</button></div>
      <div class="col-2">&nbsp;</div>
    </div>
  </div>

<div class="tab-pane fade" id="listing" role="tabpanel" aria-labelledby="listing-tab">
     <div class="row w-100 mb-4 mt-4">      
      <div class="col-2  text-right">List</div>
      <div class="col-8">
        <select name="listaprof" id="listaprof" [(ngModel)]="selLista" (change)="onListSelect()">
          <option value="0">Select</option>
          <option *ngFor="let item of adminLists" [value]="item.value">{{item.label}}</option>
        </select>        
      </div>
      <div class="col-2">&nbsp;</div>
    </div>
     <table class="table table-bordered table-hover bg-white">
      <thead class="thead-light" >
        <tr>
          <th scope="col">Name</th>
          <th scope="col">City</th>
          <th scope="col">State</th>
          <th scope="col">Specialty</th>
          <th scope="col">Hourly</th>
          <th scope="col">Since</th>
          <th scope="col"><input type="checkbox" name="selectall" id="selectall" (click)="checkAll()"></th>
        </tr>
       
      </thead>
      <tbody *ngIf="proffesionals">
        <tr *ngFor="let item of proffesionals">
          <th scope="row"><a href="javascript:void" routerLink="/prodetail/{{item.PkProffesional}}">{{item.FirstName}} {{item.Middlename}} {{item.LastName}}</a></th>
          <td>{{item.City}}</td>
          <td>{{item.State}}</td>
          <td>{{item.SpecialtyName}}</td>
          <td>${{item.HourlyRate}}</td>
          <td>{{item.Experience}}</td>
          <td><input type="checkbox" [name]="item.PkProffesional" [id]="item.PkProffesional"></td>
        </tr>
         <tr *ngIf="!proffesionals.length || proffesionals.length<1"><td colspan="7">Please select a list</td></tr>
      </tbody>    
    </table>
    <div class="d-flex w-100 justify-content-end">
      <button class="btn btn-outline-secondary" (click)="removeFromList()">Remove from list</button>
    </div>
    <hr>
     <nav aria-label="...">
      <ul class="pagination pagination-md">
      <li *ngFor="let item of pages"  [class]="(item==currentPage)?'page-item disabled':'page-item'"><a href="javascript:void(0)" class="page-link" (click)="loadPage(item)">{{item}}</a></li>
    </ul>
    </nav>
    <br>
  </div>
</div>
<div class="row" *ngIf="sent">
      <br><br><br>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <span><b>Received:</b> {{received.length}} messages.&nbsp;&nbsp;&nbsp;&nbsp;</span><br>
      <span><b>Sent:</b> {{sent.length}} messages.&nbsp;&nbsp;&nbsp;</span><br><br>
      <span>Select the tab to see the messagges.</span><br><br>
</div>
<!--
  <nav aria-label="...">
    <ul class="pagination pagination-md">
      <li *ngFor="let item of pages"  [class]="(item==currentPage)?'page-item disabled':'page-item'"><a href="javascript:void(0)" class="page-link" (click)="loadPage(item)">{{item}}</a></li>
    </ul>
  </nav>-->
  <br>
</div>
<app-footer></app-footer>